import qs from 'qs'

import { DateTime } from "luxon"

const fields = [
  'title',
  'slug',
  'locale',
  'dateStart',
  'dateEnd',
  'externalLocation',
]

const populate = {
  coverImage: '*',
}

export const queryExhibitionEntriesThumbnailByDateRange = (options: QueryManyOptionsExhibitionEntriesi18n) => {
  const startOfYear = DateTime.now().startOf('year').setZone("Europe/Amsterdam").toFormat('yyyy-LL-dd')
  const endOfYear = DateTime.now().endOf('year').setZone("Europe/Amsterdam").toFormat('yyyy-LL-dd')
  const dateStart = options?.dateStart || startOfYear
  const dateEnd = options?.dateEnd || endOfYear

  const query = qs.stringify(
    {
      locale: options?.locale || 'nl-NL',
      pagination: {
        page: options?.page || 1,
        pageSize: options?.pageSize || 100
      },
      sort: ['dateStart:desc', 'dateEnd:desc', 'title:asc'],
      filters: {
        $or: [
          {
            $and: [
              { dateStart: {  $gte: dateStart } },
              { dateEnd: { $lte: dateEnd } }
            ]
          },
          {
            $and: [
              { dateStart: { $gte: dateStart } },
              { dateStart: { $lte: dateEnd } },
              { dateEnd: { $gte: dateEnd } }
            ]
          },
          {
            $and: [
              { dateStart: { $lte: dateStart } },
              { dateEnd: { $gte: dateStart } },
              { dateEnd: { $lte: dateEnd } }
            ]
          },
          {
            $and: [
              { dateStart: { $lte: dateStart } },
              { dateEnd: { $gte: dateEnd } }
            ]
          },
        ]
      },
      fields: fields,
      populate: {
        localizations: {
          fields: fields,
          populate: {
            ...populate
          }
        },
        ...populate
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `exhibition-entries?${query}`
}
